import { HotelProvider } from '@hotels/hotel-results/entities/hotel-searched';

export function  isMarriottProvider(provider: HotelProvider): boolean {
  return provider === HotelProvider.MarriottBonvoy;
}
